import { render } from "./InternetChecker.vue?vue&type=template&id=27ba86f6"
import script from "./InternetChecker.vue?vue&type=script&lang=js"
export * from "./InternetChecker.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__